import React from "react";
import Header from "../../Header";
import Footer from "../../Footer";
import "./style.scss";
import { Row, Col, Spin, Button } from "antd";
import { connect } from "react-redux";
import moment from "moment";
import {
  jobOffers,
  jobOffer,
  applyJob,
  companyDetails,
} from "../../../store/actions/user/jobOffers";
// import FilterAndSearch from '../Filter';
import Job from "../Job/jobBreif";
import { Link } from "react-router-dom";

const EmptyJobsState = ({ onRefresh }) => {
  return (
    <div className="empty-jobs-state">
      <div className="empty-jobs-content">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="rgba(0, 0, 0, 0.25)"
          version="1.1"
          width="120px"
          height="120px"
          viewBox="0 0 462.035 462.035"
        >
          <g>
            <path d="M457.83,158.441c-0.021-0.028-0.033-0.058-0.057-0.087l-50.184-62.48c-0.564-0.701-1.201-1.305-1.879-1.845   c-2.16-2.562-5.355-4.225-8.967-4.225H65.292c-3.615,0-6.804,1.661-8.965,4.225c-0.678,0.54-1.316,1.138-1.885,1.845l-50.178,62.48   c-0.023,0.029-0.034,0.059-0.057,0.087C1.655,160.602,0,163.787,0,167.39v193.07c0,6.5,5.27,11.771,11.77,11.771h438.496   c6.5,0,11.77-5.271,11.77-11.771V167.39C462.037,163.787,460.381,160.602,457.83,158.441z M408.516,134.615l16.873,21.005h-16.873   V134.615z M384.975,113.345v42.274H296.84c-2.514,0-4.955,0.805-6.979,2.293l-58.837,43.299l-58.849-43.305   c-2.023-1.482-4.466-2.287-6.978-2.287H77.061v-42.274H384.975z M53.523,155.62H36.65l16.873-21.005V155.62z M438.498,348.69H23.54   V179.16h137.796l62.711,46.148c4.15,3.046,9.805,3.052,13.954-0.005l62.698-46.144h137.799V348.69L438.498,348.69z" />
          </g>
        </svg>
        <h2>لا توجد عروض وظيفية متاحة حالياً</h2>
        <p>لم يتم العثور على أي عروض وظيفية تطابق معايير البحث الخاصة بك</p>
        <div className="empty-jobs-actions">
          <Button type="primary" size="large" onClick={onRefresh}>
            تحديث الصفحة
          </Button>
        </div>
      </div>
    </div>
  );
};

let array = [];

class Jobs extends React.Component {
  state = {
    loading: true,
    count: 1,
    search: "",
    offers: [],
    pageLoading: true,
    jobLoading: false,
    clicked: [],
    isFetching: false,
    pages: 1,
  };
  async componentDidMount() {
    await this.fetchData();
    this.refs.divScroll.addEventListener("scroll", this.handleScroll);
  }

  handleScroll = () => {
    if (
      this.refs.divScroll.scrollTop + this.refs.divScroll.clientHeight >=
      this.refs.divScroll.scrollHeight
    ) {
      this.setState({
        isFetching: true,
      });
    }
  };

  fetchData = async () => {
    const { offersData } = this.props;
    const { count, pages, offers } = this.state;
    if (pages >= count) {
      const jobOffersData = await offersData(this.state.count);
      this.setState({
        offers:
          offers.length !== 0
            ? offers.concat(jobOffersData.value.result)
            : jobOffersData.value.result,
        basedOffersArray: jobOffersData.value.result,
        count: count + 1,
        pages: jobOffersData.value.totalPages,
        pageLoading: false,
      });
    }
  };

  fetchMoreListItems = () => {
    this.fetchData();
    this.setState({
      isFetching: false,
    });
  };

  componentDidUpdate() {
    const { isFetching } = this.state;
    if (isFetching) {
      if (!isFetching) return;
      this.fetchMoreListItems();
    }
  }

  jobOffer = async (id) => {
    const { jobOffer } = this.props;
    await jobOffer(id);
  };

  applyJob = async (jobId) => {
    const { applyJob } = this.props;
    const result = await applyJob({ jobId });
    if (result) {
      this.setState({
        jobStatus: true,
      });
    }
  };

  handleFilterChange = (e, option) => {
    if (!option) {
      const { name, value } = e.target;
      this.setState(
        {
          [name]: value,
        },
        () => {
          const { filterOption, offers, basedOffersArray } = this.state;
          let sortedOffers;

          if (filterOption === "new") {
            sortedOffers = basedOffersArray;
          } else {
            var sorted = new Array();
            for (var i = offers.length - 1; i >= 0; i--) {
              sorted.push(offers[i]);
            }
            sortedOffers = sorted;
          }

          this.setState({
            offers: sortedOffers,
          });
        }
      );
    } else {
      this.setState(
        {
          [option.props.name]: option.key,
        },
        () => {
          const { filterOption, offers, basedOffersArray } = this.state;
          let sortedOffers;

          if (filterOption === "new") {
            sortedOffers = basedOffersArray;
          } else {
            var sorted = new Array();
            for (var i = offers.length - 1; i >= 0; i--) {
              sorted.push(offers[i]);
            }
            sortedOffers = sorted;
          }

          this.setState({
            offers: sortedOffers,
          });
        }
      );
    }
  };

  handleSearch = (e) => {
    const { basedOffersArray } = this.state;
    const { value } = e.target;

    const search = basedOffersArray.filter(
      (elm) =>
        elm.jobAd.job_Name.toLowerCase().indexOf(value.toLowerCase()) > -1
    );
    this.setState({
      offers: search,
      search: value,
    });
  };

  getJob = async (jobId, index) => {
    this.setState({
      jobLoading: true,
    });
    const { jobOffer } = this.props;

    const job = await jobOffer({ id: jobId });
    // const companyInfo = await company({ id: job.value.job.company._id });
    array.push(index);
    this.setState({
      job,
      jobId,
      jobLoading: false,
      selected: index,
      clicked: array,
      // companyInfo
    });
  };

  handleRefresh = async () => {
    this.setState({
      pageLoading: true,
      count: 1,
      offers: [],
      pages: 1
    });
    await this.fetchData();
  };

  render() {
    const {
      offers,
      job,
      jobId,
      // count,
      // search,
      selected,
      jobLoading,
      pageLoading,
      clicked,
      // companyInfo
    } = this.state;

    return (
      <React.Fragment>
        <div>
          <Header />
          <div className="user-container">
            <div className="user-jobs">
              {/* <FilterAndSearch
                handleChange={this.handleFilterChange}
                handleSearch={this.handleSearch}
              /> */}

              <Spin
                spinning={pageLoading}
                size="large"
                style={{ marginTop: "50px" }}
              >
                <Row>
                  <Col md={12} sm={24} className="mobile-view">
                    <h2 className="job-header-title">التفاصيل</h2>
                    <Spin
                      spinning={jobLoading}
                      size="large"
                      style={{ marginTop: "50px" }}
                    >
                      {job && (
                        <Job
                          job={job}
                          jobId={jobId}
                        // companyDetails={companyInfo}
                        />
                      )}
                    </Spin>
                  </Col>
                  <Col md={12} sm={24}>
                    <h2 className="job-header-title">العرض الوظيفي</h2>
                    <div
                      className="jobs-section"
                      ref="divScroll"
                      id="jobs-section-scroll"
                    >
                      {offers ? (
                        offers.map((elm, index) => {
                          return (
                            <div
                              className={
                                elm.isRead ||
                                  selected === index ||
                                  clicked.includes(index)
                                  ? "job active"
                                  : "job un-read"
                              }
                              key={elm.jobAd._id}
                              onClick={() => this.getJob(elm.jobAd._id, index)}
                            >
                              <div className="top-section">
                                {elm.imagePath && elm.imagePath !== "null" ? (
                                  <img
                                    className="job-img"
                                    src={elm.imagePath}
                                    alt=""
                                  />
                                ) : (
                                  <img
                                    alt=""
                                    className="job-img"
                                    src={require("../../../images/pure-avatar.png")}
                                  />
                                )}
                                <div className="job-content">
                                  <h3 className="job-ad-name">
                                    {elm.jobAd.job_Name} 
                                  </h3>
                                  <h4>{elm.compName}</h4>
                                </div>
                                <div className="job-status">
                                  {elm.status ? (
                                    <div style={{ color: "#5fcf84" }}>
                                      تم التقدم للعمل
                                    </div>
                                  ) : (
                                    <React.Fragment>
                                      <div style={{ color: "#3a77b0" }}>
                                        لم يتم التقدم
                                      </div>
                                      {elm.jobAd.isLock ? (
                                        <div style={{ color: "#ffa76a" }}>
                                          {" "}
                                          لقد اكتمل العدد
                                        </div>
                                      ) : (
                                        ""
                                      )}
                                    </React.Fragment>
                                  )}
                                </div>
                              </div>
                              <div className="description">
                                <div>
                                  <h3>
                                    نوع العقد:{" "}
                                    <span>
                                      {elm.jobAd?.contract?.contractName}
                                    </span>
                                  </h3>
                                  <h3>
                                    مبلغ الراتب:{" "}
                                    <span>
                                      {elm.jobAd.salary}
                                      {""}
                                      {elm.jobAd?.contract?.contractName ===
                                        "عقود يومية"
                                        ? "/يومي"
                                        : "/شهري"}
                                    </span>
                                  </h3>
                                  <h3>
                                    مدة العقد:{" "}
                                    <span>
                                      {elm.jobAd.work_days}{" "}
                                      {/* {(elm.jobAd?.contract?.contractName ===
                                      "عقود يومية") || (elm.jobAd?.contract?.contractName ===
                                        "عقود جزئية")
                                        ? "يوم"
                                        : "شهر"} */}
                                      {elm.jobAd?.contract?.contractName ===
                                        "عقود يومية"
                                        ? "يوم"
                                        : "شهر"}
                                    </span>
                                  </h3>
                                </div>
                                <div>
                                  <h3>
                                    تاريخ بدء العمل:{" "}
                                    <span>
                                      {moment(elm.jobAd.startDate).format("ll")}
                                    </span>
                                  </h3>
                                  <h3>
                                    ساعات العمل اليومية:{" "}
                                    <span>{elm.jobAd.work_hours}</span>
                                  </h3>
                                </div>
                                
                                <Link to={`/user/job/${elm.jobAd._id}`}>
                                  <button className="job-mobile-btn">
                                    مشاهدة التفاصيل
                                  </button>
                                </Link>
                              </div>
                            </div>
                          );
                        })
                      ) : offers.length === 0 ? (
                        <EmptyJobsState onRefresh={this.handleRefresh} />
                      ) : (
                        ""
                      )}
                    </div>
                  </Col>
                </Row>
              </Spin>
            </div>
          </div>
        </div>
        <Footer className="footer" />
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ jobOffers }) => {
  return {
    offers: jobOffers,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    offersData: (pageNo) => dispatch(jobOffers(pageNo)),
    applyJob: (params) => dispatch(applyJob(params)),
    jobOffer: (params) => dispatch(jobOffer(params)),
    company: (params) => dispatch(companyDetails(params)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Jobs);
